import { Action } from '../core';

export const WINDOW_RESIZE = { entity: 'WINDOW_RESIZE', action: Action.HANDLE };
